import BaseHero from '@components/features/landing-pages/BaseHero';

const Hero = () => {
  return (
    <BaseHero
      header="Your Medicare Broker for life"
      subheader="Our team of Licensed Brokers rigorously sort through hundreds of plans for the one that fits you best, and make sure you get the best deal — and comprehensive coverage — year after year."
    />
  );
};

export default Hero;
